import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import AccountComponent from './js/account.component';
import ModalTriggerLoginComponent from './js/modal-trigger-login.component';
import SSOSignInComponent from './js/sso-sign-in.component';
import OauthHandlerComponent from './js/oauth-handler.component';

ComponentsFactory.getInstance().define('account', AccountComponent);
ComponentsFactory.getInstance().define('modal-trigger-login', ModalTriggerLoginComponent);
ComponentsFactory.getInstance().define('sso-sign-in', SSOSignInComponent);
ComponentsFactory.getInstance().define('oauth-handler', OauthHandlerComponent);
